import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { cannotAffordAnyOption } from "../utils/quotaCalculations";

import { useExportQuota } from "./useExportQuota";

export const useQuotaGuard = (pricePerRecord = 0) => {
    const { isLoading, isFetched, data } = useExportQuota();
    const isEnabled = salesSettingsHelper.isDataCreditsEnabled;

    return {
        isEnabled,
        isLoading,
        isBlocked: isEnabled && isFetched && cannotAffordAnyOption(data?.remaining ?? 0, pricePerRecord, 1),
        quota: data,
    };
};
